import { render, staticRenderFns } from "./AdminListaCapacitaciones.vue?vue&type=template&id=471e0abe&scoped=true"
import script from "./AdminListaCapacitaciones.vue?vue&type=script&lang=js"
export * from "./AdminListaCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./AdminListaCapacitaciones.vue?vue&type=style&index=0&id=471e0abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e0abe",
  null
  
)

export default component.exports